module.exports = __webpack_public_path__ + "img/radio-off-20.fa563684.svg";